// Chevron for the native <select>, which cannot use an MUI adornment.
const chevron =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-opacity='0.62' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")"

const styles = {
  container: {
    top: 0,
    position: 'fixed',
    right: 80,
    zIndex: 1202,
    px: 1.5,
    pt: 1,
    pb: 1.25,
    // Translated by its own height so the panel stays hidden whatever it contains
    transform: 'translateY(-100%)',
    transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderTop: 'none',
    borderRadius: 0,
    borderBottomLeftRadius: 1.5,
    borderBottomRightRadius: 1.5,
    boxShadow: 'none',
  },
  open: {
    transform: 'none',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },
  tongue: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: 40,
    height: 36,
    position: 'absolute',
    right: 0,
    bottom: -36,
    backgroundColor: 'secondary.main',
    color: 'secondary.contrastText',
    borderRadius: 0,
    borderBottomLeftRadius: 1.5,
    borderBottomRightRadius: 1.5,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.16)',
    transition: 'background-color 150ms ease-in-out',
    '&:hover': {
      backgroundColor: 'secondary.dark',
    },
    '&:focus-visible': {
      outline: '2px solid',
      outlineColor: 'secondary.dark',
      outlineOffset: 2,
    },
  },
  widget: {
    // The "Powered by Google Translate" attribution Google appends after the select
    '& .goog-te-gadget': {
      display: 'block',
      textAlign: 'center',
      fontFamily: 'inherit',
      fontSize: '0.625rem',
      lineHeight: 1,
      color: 'text.secondary',
      '& > div': {
        mb: 0.75,
      },
      '& img': {
        verticalAlign: 'middle',
      },
    },
    '& .goog-te-combo': {
      appearance: 'none',
      display: 'block',
      width: 180,
      height: 40,
      m: 0,
      pl: 1.5,
      pr: 4.5,
      fontFamily: 'inherit',
      fontSize: '0.875rem',
      color: 'text.primary',
      cursor: 'pointer',
      backgroundColor: 'background.paper',
      backgroundImage: chevron,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 12px center',
      backgroundSize: '18px 18px',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1.5,
      transition: 'border-color 150ms ease-in-out, box-shadow 150ms ease-in-out',
      '&:hover': {
        borderColor: 'text.primary',
      },
      '&:focus-visible': {
        outline: 'none',
        borderColor: 'secondary.main',
        boxShadow: (theme) => `0 0 0 3px ${theme.palette.secondary.main}29`,
      },
    },
  },
}

// Chrome Google injects into the document itself, outside our widget: a fixed banner
// that offsets the whole page, a hover tooltip and a highlight on translated text.
export const googleChromeStyles = {
  'iframe.skiptranslate, .goog-te-banner-frame': {
    display: 'none !important',
  },
  body: {
    top: '0 !important',
  },
  '#goog-gt-tt, .goog-te-balloon-frame': {
    display: 'none !important',
  },
  '.goog-text-highlight': {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
  },
}

export default styles
